exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-information[data-v-ebebfe7a] {\n  display: grid;\n  gap: var(--size-xl);\n}\n@media screen and (max-width: 992px) {\n.contact-information[data-v-ebebfe7a] {\n    gap: var(--size-lg);\n}\n}\n.contact-information__login-action[data-v-ebebfe7a] {\n  color: var(--blue-500);\n}", ""]);

// exports
